<template>
  <div
    class="bg-ontick-carbon-900 fixed inset-0 z-40 flex items-center justify-center bg-opacity-60"
    @click.self="$emit('close')"
  >
    <div class="bg-ontick-graphite-500 relative flex w-[600px] flex-col rounded-[32px] gap-8 items-center p-8">
      <!-- ============================= -->

      <button
        class="absolute top-6 right-6 cursor-pointer bg-ontick-carbon-600 p-2 rounded-full"
        @click="$emit('close')"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.244078 0.244078C0.569515 -0.0813592 1.09715 -0.0813592 1.42259 0.244078L5 3.82149L8.57741 0.244078C8.90285 -0.0813592 9.43049 -0.0813592 9.75592 0.244078C10.0814 0.569515 10.0814 1.09715 9.75592 1.42259L6.17851 5L9.75592 8.57741C10.0814 8.90285 10.0814 9.43049 9.75592 9.75592C9.43049 10.0814 8.90285 10.0814 8.57741 9.75592L5 6.17851L1.42259 9.75592C1.09715 10.0814 0.569515 10.0814 0.244078 9.75592C-0.0813592 9.43049 -0.0813592 8.90285 0.244078 8.57741L3.82149 5L0.244078 1.42259C-0.0813592 1.09715 -0.0813592 0.569515 0.244078 0.244078Z"
            fill="#9CA3AF"
          />
        </svg>
      </button>

      <!-- ============================= -->
      <div class="flex flex-col gap-2 text-center mt-4">
        <p class="font-bold text-3xl">Nome da Trade Idea</p>
        <p class="text-xs text-gray-400">Nome do parceiro</p>
      </div>
      <!-- ============================= -->
      <div class="flex gap-2">
        <ontick-broker-logo-component broker="XP" />
        <p class="text-base font-semibold text-gray-200">XP <span class="text-gray-400">(#129524)</span></p>
        <span
          class="text-xs font-semibold bg-ontick-blue-900 text-ontick-blue-500 rounded-md flex items-center justify-center px-2 h-5 ml-2"
          >PROD</span
        >
      </div>
      <!-- ============================= -->
      <p class="text-2xl text-gray-300">Encerrar investimento</p>
      <!-- ============================= -->
      <div class="flex flex-col gap-2">
        <div class="flex items-center gap-1">
          <i v-html="iconCheck"></i>
          <p class="text-xs text-gray-400">Todas as posições abertas serão fechadas</p>
        </div>
        <div class="flex items-center gap-1">
          <i v-html="iconCheck"></i>
          <p class="text-xs text-gray-400">Todas as ordens pendentes serão canceladas</p>
        </div>
      </div>
      <!-- ============================= -->
      <p class="text-xs font-semibold text-gray-300">Você está prestes a desligar este investimento</p>
      <!-- ============================= -->
      <div class="flex flex-col w-full gap-3">
        <p class="text-center text-base font-normal text-gray-400">
          Para cancelar esta pré autorização digite<br />a palavra
          <strong class="font-semibold text-gray-50">CONFIRMAR</strong> no campo abaixo.
        </p>

        <input
          type="text"
          ref="inputConfirm"
          v-model="inputConfirm"
          class="uppercase bg-ontick-carbon-500 text-lg text-gray-400 w-full rounded-md border-none focus:outline-none focus:ring-0 text-center"
          maxlength="30"
        />

        <button
          @click="$emit('confirm')"
          class="bg-ontick-red-700 mt-3 font-semibold py-2 w-full rounded-md filter hover:brightness-125 transition-all disabled:filter-none disabled:bg-gray-500 flex items-center justify-center cursor-pointer disabled:cursor-not-allowed"
          :disabled="inputConfirm.toUpperCase() !== 'CONFIRMAR'"
        >
          <!-- <i v-html="$icons.loading" v-if="loading"></i> -->
          <span class="text-lg">Encerrar trade idea</span>
        </button>
      </div>
      <!-- ============================= -->
    </div>
  </div>
</template>

<script>
import OntickBrokerLogoComponent from "../../../shared/components/basic/ontick-broker-logo.component.vue";

export default {
  name: "ModalStopTradeIdea",

  components: {
    OntickBrokerLogoComponent,
  },

  data() {
    return {
      inputConfirm: "",
      iconCheck: `
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
          <path
            d="M3.99993 7.80007L1.19993 5.00006L0.266602 5.9334L3.99993 9.66673L11.9999 1.66673L11.0666 0.733398L3.99993 7.80007Z"
            fill="#19D684"
          />
        </svg>
      `,
    };
  },

  mounted() {
    this.$refs.inputConfirm.focus();
  },
};
</script>

<style lang="scss" scoped></style>
